import axios from "axios";
import { BusinessImprovementPlanUrls } from "./BusinessImprovementPlanUrls";
import authSlice from "../../../AuthContainer/_redux/authSlice";


const { actions } = authSlice;

const getToken = (getState) => {
  return getState().authDetails.accessToken;
};

const nodeInstance = axios.create({ baseURL: process.env.REACT_APP_NEST_BASE_URL });


function defaultParams(id) {
  return {
    sme_id: id
  }
}

export const getBusinessImprovementPlanGeneralData  = (sme_id) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    nodeInstance
      .get(BusinessImprovementPlanUrls.GENERAL_DATA, {
        headers: {
          Authorization: getToken(getState)
        },
        params: defaultParams(sme_id)
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getBusinessPlanDetails =
  (businessPlanId, sme_id) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      nodeInstance
        .get(
          BusinessImprovementPlanUrls.BUSINESS_PLAN_DETAILS.replace(
            "{businessPlanId}",
            businessPlanId,
          ),
          {
            headers: {
              Authorization: getState().authDetails.accessToken,
            },
            params: defaultParams(sme_id)
          },
        )
        .then((response) => {
          let data = response.data.data;
          if(data.isArchived){
            data.latest_bip_state = "Archived" ;
            data.showActions = false;
          }else if(data.isClosed){
            data.latest_bip_state = "Closed" ;
            data.showActions = false;
          }else if(data.isPublished){
            data.latest_bip_state = "Published" ;
            data.showActions = true;
          }else{
            data.latest_bip_state = "Draft" ;
            data.showActions = true;
          }
          resolve(data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  };


export const getListOfBusinessPlans = (sme_id) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    nodeInstance
      .get(BusinessImprovementPlanUrls.LIST_OF_BUSINESS_PLANS, {
        headers: {
          Authorization: getState().authDetails.accessToken,
        },
        params: defaultParams(sme_id)
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err.response.data);
      });
  });
};

export const getBusinessPlanReport =
  (businessPlanId, sme_id) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      nodeInstance
        .get(
          BusinessImprovementPlanUrls.GET_BUSINESS_PLAN_REPORT.replace(
            "{businessPlanId}",
            businessPlanId,
          ),
          {
            responseType: "blob",
            headers: {
              Authorization: getState().authDetails.accessToken,
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            params: defaultParams(sme_id)
          },
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  };

  export const getObjectiveDetails = (objectiveId, sme_id) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      nodeInstance
        .get(
          BusinessImprovementPlanUrls.GET_OBJECTIVE_DETAILS.replace(
            "{objectiveId}",
            objectiveId,
          ),
          {
            headers: {
              Authorization: getState().authDetails.accessToken,
            },
            params: defaultParams(sme_id)
          },
        )
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  };